import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=3448d1b5&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=3448d1b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448d1b5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Share: require('/workspace/components/Share.vue').default,FaqCardPost: require('/workspace/components/FaqCardPost.vue').default,ReviewCard2: require('/workspace/components/ReviewSection/ReviewCard2.vue').default,PlaceCard: require('/workspace/components/PlaceCard.vue').default,ActivityCard: require('/workspace/components/ActivityCard.vue').default})
